import { useMutation } from '@tanstack/react-query';

import { type CrmClient } from '@zep/crm/quotes';

import {
  type QuizQuoteApiRequest,
  sendQuizQuoteNotification,
} from '../shared/utils/quizQuoteApi';

/**
 * 견적 접수(CRM `POST /api/crm/v1/quotes/quiz`) 뮤테이션.
 *
 * 재시도하지 않는다 — 접수는 원장에 행을 만들고 메일·알림톡까지 보내므로 중복이
 * 위험하고, CRM 레이트리밋도 IP 3/분이라 재시도가 곧 차단이다.
 *
 * `crm` 은 스토리·테스트가 가짜 클라이언트를 넣기 위한 자리다.
 */
export function useSendQuizQuote(crm?: CrmClient) {
  return useMutation({
    mutationFn: (request: QuizQuoteApiRequest) =>
      sendQuizQuoteNotification(request, crm),
    retry: 0,
  });
}
